import { accessorialRateListQuerySchema, type AccessorialRateListQuery } from '@chukua/common';
import { useCallback, useMemo } from 'react';
import { useListQuery } from '../../../../../shared/hooks/use-list-query';
import { usePagedList } from '../../../../../shared/hooks/use-paged-list';
import { listAccessorialRates } from '../../../rate-cards.api';

/** A card's accessorial rates for the URL's list query; like the lines, what is in force unless told otherwise. */
export function useAccessorialRates(rateCardId: string) {
  const list = useListQuery(accessorialRateListQuerySchema);
  const query = useMemo<AccessorialRateListQuery>(() => ({ ...list.query, current: list.query.current ?? true }), [list.query]);
  const load = useCallback((q: AccessorialRateListQuery) => listAccessorialRates(rateCardId, q), [rateCardId]);
  return { list, query, ...usePagedList(query, load) };
}
